module.exports = __webpack_public_path__ + "img/mano.c4878c2e.png";